@if (language()) {
  <span
    class="profiler-language-flag"
    aria-hidden="true"
    [matTooltip]="'profilerLanguage.usage' | translate: {language: labelKey() | translate}"
    [matTooltipDisabled]="!showTooltip"
    matTooltipTouchGestures="off"
  >
    @if (language() === 'en') {
      <svg class="profiler-language-flag__svg" viewBox="0 0 60 30" aria-hidden="true" focusable="false">
        <clipPath [attr.id]="clipId">
          <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/>
        </clipPath>
        <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" stroke-width="6"/>
        <path d="M0,0 L60,30 M60,0 L0,30" [attr.clip-path]="'url(#' + clipId + ')'" stroke="#C8102E" stroke-width="4"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#FFFFFF" stroke-width="10"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/>
      </svg>
    } @else {
      <svg class="profiler-language-flag__svg" viewBox="0 0 60 30" aria-hidden="true" focusable="false">
        <path d="M0,0 h60 v10 h-60 z" fill="#000000"/>
        <path d="M0,10 h60 v10 h-60 z" fill="#DD0000"/>
        <path d="M0,20 h60 v10 h-60 z" fill="#FFCE00"/>
      </svg>
    }
  </span>
}
